import React, { useEffect } from 'react';
import { SetPageTitle } from '../../utilities/TitleHelper';

 
const Error404 = () => {
  useEffect(() => {
    SetPageTitle("404");
  }, [])

  return (
    <div className="row flex-center justify-content-center min-vh-100 py-6 text-center">
      <div className="col-sm-10 col-md-8 col-lg-6 col-xxl-5">

        <h1 className="mt-5" style={{fontSize:120, color:'lightgray'}}>404</h1>

        <div className="card" id="crd404">
          <div className="card-body p-4 p-sm-5">
            <div className="fw-black lh-1 text-300 fs-error">404</div>
            <p className="lead mt-4 text-800 font-sans-serif fw-semi-bold">The page you're looking for is not found.</p>
            <hr />
            <p>Try refreshing the page, or going back and attempting the action again.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Error404;